module.exports = __webpack_public_path__ + "img/6.c67ff10f.webp";